import { BsCustomerManagementPageHeaderTab } from './BsCustomerManagementPageHeaderTab';
export default BsCustomerManagementPageHeaderTab;
